// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientSearchModelResponse {
    static getAttributeTypeMap() {
        return PatientSearchModelResponse.attributeTypeMap;
    }
}
PatientSearchModelResponse.discriminator = undefined;
PatientSearchModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PatientSearchResponseModel"
    }
];
//# sourceMappingURL=patientSearchModelResponse.js.map